<script>
  export default {
    name: 'summary',
    props: {},
    render (h) {
      return (<div class="mod-summary">
        <div class="mod-summary-bg">
          <div class="mod-title">
            <span class='title'>{this.$scopedSlots.title || this.$slots.title}</span>
            <span class='after-title'>{this.$scopedSlots.afterTitle || this.$slots.afterTitle}</span>
          </div>
          <sy-form size="small" class='form-summary' span={3}>
            {
              this.$scopedSlots.default || this.$slots.default
            }
          </sy-form>
        </div>
      </div>)
    }
  }
</script>

<style scoped lang="scss">
  .mod-summary {
    // background-color: #ECEFF2;
    // padding-bottom: 10px;
    padding: 0 32px;
    border: 1px solid #d6dfff;
    border-radius: 8px;
    background: #fff;

    .mod-summary-bg {
      background: #fff;
    }

    .mod-title {
      line-height: 50px;
      position: relative;

      .title {
        margin-right: 6px;
        font-family: PingFang SC;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
      }

      .title:before {
        content: "";
        width: 3px;
        display: inline-block;
        background: #3072f3;
        position: absolute;
        left: -8px;
        top: 16px;
        bottom: 6px;
        height: 14.3px;
      }

      .after-title > * {
        margin-right: 6px;
        display: inline-block;
        vertical-align: middle;
      }


    }

    .form-summary {
      // padding: 0 24px 20px;
      overflow: hidden;

      // background: #F5F5F5;
      // ::v-deep .sy-form-item {
      //   width: 31.5% !important;
      // }
      ::v-deep .el-form-item__label {
        font-size: 14px !important;
        padding-right: 4px !important;
      }

      ::v-deep .el-form-item__content {
        color: #F70007;
        // padding-top: 8px;
      }


      .summary-list {


        background: #F5F5F5;
        padding: 12px 0 0 0;

        .sy-form-item {
          margin-bottom: 20px !important;
          padding-left: 20px;
        }

        .summary-item {
          width: 31.5%;
          float: left;

          .summary-item-title {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #707070;
            letter-spacing: 0;
            line-height: 16px;
            font-weight: 400;
          }

          .summary-item-content {
            color: #303030;
            font-size: 16px;
            font-weight: normal;
            line-height: 20px;

            ::v-deep .detail-default-component {
              line-height: 16px;
            }
          }
        }
      }
    }
  }
</style>
